import dayjs from "dayjs"

export const getRemainingTime = (nearestEnrollmentConnection) => {
  const targetDate = dayjs.utc(nearestEnrollmentConnection)
  const now = dayjs()
  const diff = targetDate.diff(now)
  const diffDays = Math.floor(diff / (24 * 60 * 60 * 1000))
  const diffHours = Math.floor((diff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000))

  return { days: diffDays ? diffDays : 2, hours: diffHours }
}
